import React, { useState, useCallback, useEffect } from 'react';
import block from 'bem-cn';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';

import Select from 'components/Select/desktop';
import Button from 'components/Button';
import DateInput from 'components/DateInput';
import Input from 'components/Input';

import DaysFilter from 'features/reports/view/DaysFilter';

import { statusSportBets } from 'features/reports/data';

import { actions } from 'features/reports/redux';

import './FilterBlock.scss';

const b = block('filter-block-player-history-general');

const FilterBlock = ({ count, currentPage, isMobile, onPageClick }) => {
  const locale = useSelector(state => state.locale.locale);
  const dispatch = useDispatch();
  const [date, setDate] = useState({
    beginDate: new Date(dayjs().add(-1, 'day')),
    endDate: new Date(dayjs()),
  });
  const [activeDay, setActiveDay] = useState('');
  const [filters, setFilters] = useState({
    user: '',
    statusBet: statusSportBets[0],
  });

  const onChangeBeginDate = value => {
    if (!isNaN(value.valueOf())) {
      setDate({ ...date, beginDate: value });
    }

    setActiveDay('');
  };

  const onChangeEndDate = value => {
    if (!isNaN(value.valueOf())) {
      setDate({ ...date, endDate: value });
    }
  };

  const handleUserChange = useCallback(
    e => {
      setFilters({ ...filters, [e.currentTarget.name]: e.currentTarget.value });
    },
    [filters],
  );

  const handleStatusBetChange = value => {
    const statusBet = statusSportBets.find(item => item.value === value);
    setFilters({ ...filters, statusBet: statusBet });
  };

  useEffect(() => {
    handleSearch();
  }, [count, currentPage]);

  const onClickSearch = () => {
    handleSearch();
    onPageClick(0);
  };

  const handleSearch = () => {
    const requestedData = {
      username: filters.user,
      couponId: filters.couponId,
      count,
      status: filters.statusBet.value,
      page: currentPage,
      ...date,
    };
    dispatch(actions.getBetsHistory(requestedData));
  };

  const onChangeActiveDay = useCallback(dayFilter => {
    setActiveDay(dayFilter);
    setDate({ ...date, beginDate: new Date(dayjs().add(dayFilter.value, 'day')) });
  }, []);

  return (
    <div className={b({ isMobile })}>
      <DaysFilter activeDay={activeDay} setActiveDay={onChangeActiveDay} isMobile={isMobile} />

      <div className={b('block')}>
        <div className={b('filter-row')}>
          <DateInput
            name="dateFrom"
            text="dateFrom"
            size="middle"
            rounded
            format="dd/MM/yyyy"
            value={date.beginDate}
            onChange={onChangeBeginDate}
          />
        </div>
        <div className={b('filter-row')}>
          <DateInput
            name="dateUntil"
            text="dateUntil"
            size="middle"
            rounded
            format="dd/MM/yyyy"
            value={date.endDate}
            onChange={onChangeEndDate}
          />
        </div>

        <div className={b('filter-row')}>
          <p className={b('filter-row', 'title')}>{locale.user}</p>
          <Input
            size="low"
            type="lowWhite"
            value={filters.user}
            callBack={handleUserChange}
            placeholder={locale.username}
            name="user"
          />
        </div>
      </div>
      <div className={b('block')}>
        <div className={b('filter-row')}>
          <p className={b('filter-row', 'title')}>{locale.statusBet}</p>
          <Select
            name="statusBets"
            items={statusSportBets}
            activeItem={filters.statusBet}
            onChange={handleStatusBetChange}
          />
        </div>

        <div className={b('search-btn')}>
          <Button callBack={() => onClickSearch()} text={locale.search} search />
        </div>
      </div>
    </div>
  );
};

export default FilterBlock;
